import React, { useEffect, useState } from 'react';

import {
  IVariation,
  IVariationContainerFields
} from '../../../types/contentful';

import { useOptimizely, DEFAULT_VARIATION } from '../../context/Optimizely';

import { isSsr } from '../../utils/isSsr';

import { Variation } from '../Variation';

interface VariationContainerProps extends IVariationContainerFields {
  sysId?: string;
}

export function VariationContainer({
  experimentKey = '',
  variations,
  sysId
}: VariationContainerProps) {
  const [isRendered, setIsRendered] = useState(false);

  const experiments = useOptimizely();

  const variationKey =
    experiments[experimentKey]?.enabled &&
    experiments[experimentKey]?.variationKey !== ''
      ? experiments[experimentKey]?.variationKey
      : DEFAULT_VARIATION;

  // TODO: how should this work with SSR?
  useEffect(() => {
    setIsRendered(true);
  }, []);

  return (
    <div
      className={`vc-${experimentKey}`}
      data-elid={sysId}
      data-expid={experimentKey}
    >
      {variations?.map(({ sys, fields }: IVariation) => {
        if (
          sys?.contentType?.sys?.id === 'variation' &&
          (isSsr() || !isRendered || variationKey === fields.variationKey)
        ) {
          return (
            <Variation
              {...fields}
              key={sys?.id}
              className={`vc-${experimentKey}__variation--${fields.variationKey} vc-${experimentKey}__variation`}
              isActive={variationKey === fields.variationKey}
            />
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
